/* eslint-disable prettier/prettier */
import React from "react";
import { SubscriptionTestimonial } from "./subscription-testimonial";
import { SubscriptionCollection } from "./subscription-collection";
import { SubscriptionBlocks } from "./subscription-blocks";
import { Features } from "./features";
import { SubscriptionPlaylist } from "./subscription-playlist";
import { Faq } from "./faq";
import { SubscriptionExplained } from "./subscription-explained";
import { SubscribersMeetSlider } from "./subscribers-meet-slider"; 


export const SubscriptionPage = props => {
  return (
    <div>
      <SubscriptionBlocks {...props} />
      <Features />

      <SubscribersMeetSlider/>
      <br/><br/><br/>
      <SubscriptionTestimonial {...props} />
      <br />
      <SubscriptionCollection {...props} />
      <SubscriptionPlaylist />
      <SubscriptionExplained {...props} />
      
      <Faq />
    </div>
  );
};
